import styled, { css } from 'styled-components';
import { COLOURS, FONT_WEIGHT, mediaMap } from '@belong/themes';
import { IHeading, OUTER_SPACING } from '@belong/types';
import { Copy, Heading, ICopy, withLink } from '@belong/ui-components';
import { spacingRules } from '@belong/ui-components/components/layout/OuterSpacing';

export const Term = styled(Heading).attrs<IHeading>({
  as: 'dt',
  variant: 'xsmall'
})`
  padding-bottom: 0.4rem;
  padding-left: 0.8rem;

  ${mediaMap(
    spacingRules[OUTER_SPACING.COMPACT],
    (padding: string) => css`
      padding-top: ${padding};
    `
  )}
`;

export const Description = styled(Copy).attrs<ICopy>({
  as: 'dd',
  variant: 'small',
  hasColor: COLOURS.GREY_600
})`
  border-bottom: 1px solid ${COLOURS.GREY_300};
  padding-left: 0.8rem;

  &:last-child {
    border-bottom: none;
  }

  ${mediaMap(
    spacingRules[OUTER_SPACING.COMPACT],
    (padding: string) => css`
      padding-bottom: ${padding};
    `
  )}
`;

export const StyledList = styled.dl`
  em {
    font-weight: ${FONT_WEIGHT.BOLD};
    font-style: normal;
  }
`;

export const Link = withLink(styled.a`
  text-decoration: underline;
  color: ${COLOURS.DARK_BLUE};

  &:hover {
    text-decoration: none;
  }

  &:visited {
    color: ${COLOURS.DARK_PURPLE};
  }
`);
